import React, { FC } from "react";
import DialogWizard from "../../DialogComponents/DialogWizard/DialogWizard";
import { AddProxyServiceFinish } from "./AddProxyServiceFinish";
import { AddProxyServiceLayers } from "./AddProxyServiceLayers";
import { AddProxyServiceMeta } from "./AddProxyServiceMeta";
import { useAddProxyServiceContext } from "./AddProxyServiceProvider";
import { AddProxyServiceType } from "./AddProxyServiceType";
import { ProxyServiceType } from "./types";

export const AddProxyServiceSteps: FC = () => {
  const { serviceType, step } = useAddProxyServiceContext();

  return [ProxyServiceType.WMS, ProxyServiceType.ArcGIS].includes(serviceType) ? (
    <DialogWizard
      currentStep={step}
      steps={[AddProxyServiceType, AddProxyServiceLayers, AddProxyServiceMeta, AddProxyServiceFinish]}
    />
  ) : (
    <DialogWizard currentStep={step} steps={[AddProxyServiceType, AddProxyServiceMeta, AddProxyServiceFinish]} />
  );
};
